import axios from "axios";
import { createAsyncThunk,createSlice } from "@reduxjs/toolkit";

export const STATUSES = Object.freeze({
    IDLE : 'idle',
    ERROR:'error',
    LOADING: 'loading',
});

const getVerifyAndDeleteJockeySlice = createSlice({
    name: 'VerifyAndDeleteJockey',
    initialState: {
        data:[],
        status : STATUSES.IDLE,
    },

    extraReducers: (builder) => {
        builder
        .addCase(fetchVerifyAndDeleteJockey.pending, (state, action) => {
            state.status = STATUSES.LOADING;
        })
        .addCase(fetchVerifyAndDeleteJockey.fulfilled, (state, action) => {
            state.data = action.payload;
            state.status = STATUSES.IDLE
        }) 
        .addCase(fetchVerifyAndDeleteJockey.rejected , (state,action) => {
            state.status = STATUSES.ERROR;
        })
    }
});

export const {setVerifyAndDeleteJockey , setStatus} = getVerifyAndDeleteJockeySlice.actions;
export default getVerifyAndDeleteJockeySlice.reducer;

export const fetchVerifyAndDeleteJockey = createAsyncThunk('/getVerifyAndDeleteJockey/fetch', async({id}) => {
    const res = await axios.delete(`${window.env.API_URL}/VerifyAndDeleteJockey/${id}`);
    const VerifyAndDeleteJockeyData = res.data;
    return VerifyAndDeleteJockeyData.data;
})